<template>
  <funnel-step-layout anchor="objectives">
    <div>{{$t(`step2.${entity}.${goal}_description`)}}</div>
    <div id="objectives_solutions_container" class="container mb-4">
      <div class="row">
        <div class="col-12 mt-5">
          <bubbles>
            <bubble-item
              v-for="(option, id) in structure[entity][goal]"
              @click="onSelectTarget"
              @touch="onTouchTarget"
              :key="id"
              :value="id"
              :id="id"
              :extra="{features: $t(`step2.${entity}.${goal}.${id}.feature`)}"
              :label="$t(`step2.${entity}.${goal}.${id}.title`)"
              :icon="$t(`step2.${entity}.${goal}.${id}.icon`)"
              :selected="inputs.objectives_services.includes(id)"
              :description="{text: $t(`step2.${entity}.${goal}.${id}.description`), image: $t(`step2.${entity}.${goal}.${id}.image`) }"
             >
             <span slot="description">
               <span class="preview-desc"><img v-if="structure[entity][goal][id].image" :src="$t(`step2.${entity}.${goal}.${id}.image`)" /></span>
               <span class="description-text">{{$t(`step2.${entity}.${goal}.${id}.description`)}}</span>
             </span>
             </bubble-item>
          </bubbles>
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-center d-md-none">
          <px-button class="d-block d-md-none" :disabled="!canGoNext" @click="goNextStep('next')" :text="$t('common.next_cta')"></px-button>
      </div>
    </div>
    <px-button v-if="!nextIsDisplayed" class="nextBtn d-none d-md-block" :disabled="!canGoNext" @click="goNextStep" :text="$t('common.next_cta')"></px-button>
  </funnel-step-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import {FunnelStepLayout} from '@/components/Layouts'
import { Bubbles, BubbleItem } from '@/components/UIComponents'

export default {
  name: 'step-objectives-solutions-option',
  components: {
    FunnelStepLayout,
    Bubbles,
    BubbleItem
  },
  data () {
    return {
      previousTouched: null
    }
  },
  methods: {
    onTouchTarget (item) {
      if (this.previousTouched) {
        if (item.id !== this.previousTouched.id) {
          this.previousTouched.removeTouch()
        }
      }
      this.previousTouched = item
      this.$store.dispatch('form/options_objectives_services', {value: item.value, features: item.extra.features})
    },
    onSelectTarget (item) {
      this.$store.dispatch('form/options_objectives_services', {value: item.value, features: item.extra.features})
    },
    goNextStep (move) {
      if (this.canGoNext) {
        this.$store.dispatch('form/goLocations')
        if (move === 'next') {
          this.$onePage.moveNext()
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      entity: 'form/entity',
      goal: 'form/goal',
      inputs: 'form/inputs',
      structure: 'form/step2_structure',
      canGoNext: 'form/has_selected_objectives_services',
      nextIsDisplayed: 'form/can_display_locations'
    })
  }
}
</script>

<style lang="scss">

  @import "~bootstrap/scss/functions";
  @import '~bootstrap/scss/variables';

  .nextBtn {
    position: absolute;
    bottom: 25vh;
  }
  .preview-desc{
    display: block;
    margin-bottom: .75em;
    max-width: 90%;
    margin-left: 5%;
    text-align: center;
    img {
      max-width: 100%;
      max-height: 100%;
    }
  }

  #objectives_solutions_container {
    @media screen and (min-width: map-get($grid-breakpoints, md)){
      height:250px;
    }
  }
</style>
